import { Fragment } from "react";
import { Route, Routes } from "react-router-dom";

import HomePage from "../../pages/HomePage";
import PageNotFound from "../../pages/PageNotFound";
import UserPage from "../../pages/UserPage";
import SingleCustomerComplexPage from "../Customer/SingleCustomerComplexPage";
import CustomerList from "../Home/CustomerList";
import CustomerMeasurementList from "../Measurement/CustomerMeasurementList";
import ProductMeasurementSetting from "./../Measurement/ProductMeasurementSetting";
import Product from "./../Product/Product";
import SMSBalance from "./../SMS/SMSBalance";
import WorkSteps from "./../WorkProcess/WorkSteps";
import AccessorySelect from "./../Accessories/AccessorySelect";

const RoutingAuthorized = () => {
  return (
    <Fragment>
      <Routes>
        <Route path="*" element={<PageNotFound />} />
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/Home" element={<HomePage />} />
        {/* <Route exact path="/SearchOrder" element={<SearchOrderOrItemTracking />} /> */}
        <Route exact path="/Customer" element={<CustomerList />} />
        <Route exact path="/WorkSteps" element={<WorkSteps />} />
        <Route exact path="/SMSBalance" element={<SMSBalance />} />

        <Route
          exact
          path="/ProductMeasurementSetting"
          element={<ProductMeasurementSetting />}
        />
        <Route exact path="/Product" element={<Product />} />
        <Route exact path="/Accessories" element={<AccessorySelect />} />
        {/* <Route exact path="/Product/:code" element={<Product />} /> */}

        <Route
          path="/Customer/:cusid"
          element={<SingleCustomerComplexPage mode="1" />}
        />
        <Route
          exact
          path="/Customer/:cusid/:innerpage"
          element={<SingleCustomerComplexPage mode="2" />}
        />
        <Route
          exact
          path="/Customer/:cusid/:innerpage/:innerpageid"
          element={<SingleCustomerComplexPage mode="3" />}
        />

        <Route
          exact
          path="/Customer/:cusid/:innerpage/:innerpageid/:innerpage2"
          element={<SingleCustomerComplexPage mode="4" />}
        />

        <Route
          exact
          path="/Measurement/:cusid"
          element={<CustomerMeasurementList />}
        />
        <Route path="/Users" element={<UserPage />} />
      </Routes>
    </Fragment>
  );
};

export default RoutingAuthorized;
